import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { Daterangepicker } from 'ng2-daterangepicker';
import { TooltipModule } from 'ng2-tooltip-directive';
import { NgxPaginationModule } from 'ngx-pagination';
import {
	PerfectScrollbarConfigInterface,
	PerfectScrollbarModule,
	PERFECT_SCROLLBAR_CONFIG
} from 'ngx-perfect-scrollbar';
import { SortablejsModule } from 'ngx-sortablejs';
import { UiSwitchModule } from 'ngx-toggle-switch';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { FqAudioPlayerModule, FqAudioPlayerComponent } from '@frequence/ui-kit/fq-audio-player';
import { FqChartModule } from '@frequence/ui-kit/fq-chart';
import { FqCreativeModule } from '@frequence/ui-kit/fq-creative';
import { FqProgressBarModule } from '@frequence/ui-kit/fq-progress-bar';
import { FqVideoPlayerModule } from '@frequence/ui-kit/fq-video-player';
import { NgSelectModule } from '@ng-select/ng-select';
import { NguCarouselModule } from '@ngu/carousel';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { SafeUrlPipe } from '../../core/utility/pipes/safe-url.pipe';
import { BreadcrumbDrawerComponent } from '../../reporting/dashboard/breadcrumb/components/breadcrumb-drawer/breadcrumb-drawer.component';
import { AnalyticsCoreModule } from '../analytics-core/analytics-core.module';
import { NavigationModule } from '../dashboard/navigation/navigation.module';
import { SharedModule } from '../shared/shared.module';
import { NgxCarousel3dModule } from '../widget-library/widgets/ngx-carousel-3d/ngx-carousel-3d.module';
import { WidgetLibraryComponent } from './components/widget-library.component';
import { FormatNumberPipe } from './pipes/FormatNumber';
import { SearchReportAttributesPipe } from './pipes/search-report-attibutes.pipe';
import { WidgetLibraryService } from './services/widget-library.service';
import { AccordionGroupComponent } from './widgets/accordion/accordion-group/accordion-group.component';
import { AccordionComponent } from './widgets/accordion/accordion.component';
import { BaseWidgetComponent } from './widgets/base-widget/base-widget.component';
import { CarouselComponent } from './widgets/carousel/carousel.component';
import { ChartV3Component } from './widgets/chart-v3/chart-v3.component';
import { ChartComponent } from './widgets/chart/chart.component';
import { CreativeAdPreviewComponent } from './widgets/creative-ad-preview/creative-ad-preview.component';
import { CreativeCarouselR5Component } from './widgets/creative-carousel-r5/creative-carousel-r5.component';
import { CreativeCarouselComponent } from './widgets/creative-carousel/creative-carousel.component';
import { CreativeDetailV2Component } from './widgets/creative-detail-v2/creative-detail-v2.component';
import { CreativeDetailV7Component } from './widgets/creative-detail-v7/creative-detail-v7.component';
import { CreativePerformanceGraphComponent } from './widgets/creative-performace-v1/creative-performance-graph/creative-performance-graph.component';
import { CreativePerformanceStatsComponent } from './widgets/creative-performace-v1/creative-performance-stats/creative-performance-stats.component';
import { CreativePerformanceV1Component } from './widgets/creative-performace-v1/creative-performance-v1.component';
import { CreativePerformanceGraphV7Component } from './widgets/creative-performance-v7/creative-performance-graph-v7/creative-performance-graph-v7.component';
import { CreativePerformanceStatsV7Component } from './widgets/creative-performance-v7/creative-performance-stats-v7/creative-performance-stats-v7.component';
import { CreativePerformanceV7Component } from './widgets/creative-performance-v7/creative-performance-v7.component';
import { CreativeR10Component } from './widgets/creative-r10/creative-r10.component';
import { CreativeR5GraphComponent } from './widgets/creative-r5-graph/creative-r5-graph.component';
import { CreativesCoxV5Component } from './widgets/creatives-cox-v5/creatives-cox-v5.component';
import { CreativesR5Component } from './widgets/creatives-r5/creatives-r5.component';
import { CtvCreativeDetailV2Component } from './widgets/ctv-creative-detail-v2/ctv-creative-detail-v2.component';
import { CtvCreativeDetailV3Component } from './widgets/ctv-creative-detail-v3/ctv-creative-detail-v3.component';
import { CtvCreativeDetailV4Component } from './widgets/ctv-creative-detail-v4/ctv-creative-detail-v4.component';
import { CtvCreativeR1Component } from './widgets/ctv-creative-r1/ctv-creative-r1.component';
import { CtvCreativeR5Component } from './widgets/ctv-creative-r5/ctv-creative-r5.component';
import { CtvDaypartR7Component } from './widgets/ctv-daypart-r7/ctv-daypart-r7.component';
import { CtvDaypartsR1Component } from './widgets/ctv-dayparts-r1/ctv-dayparts-r1.component';
import { CtvFeaturedNetworksR1Component } from './widgets/ctv-featured-networks-r1/ctv-featured-networks-r1.component';
import { CtvFeaturedNetworksComponent } from './widgets/ctv-featured-networks/ctv-featured-networks.component';
import { CtvNetworkDonutComponent } from './widgets/ctv-featured-networks/ctv-network-donut/ctv-network-donut.component';
import { CtvPerformanceDetailV4Component } from './widgets/ctv-performance-detail-v4/ctv-performance-detail-v4.component';
import { CtvPlatformPerformanceR3Component } from './widgets/ctv-platform-performance-r3/ctv-platform-performance-r3.component';
import { CtvPlatformPerformanceComponent } from './widgets/ctv-platform-performance/ctv-platform-performance.component';
import { CtvQuickstatsR1Component } from './widgets/ctv-quickstats-r1/ctv-quickstats-r1.component';
import { CtvQuickstatsR7Component } from './widgets/ctv-quickstats-r7/ctv-quickstats-r7.component';
import { CustomDropdownComponent } from './widgets/custom-dropdown/custom-dropdown.component';
import { DailyEnagementsV3Component } from './widgets/daily-enagements-v3/daily-enagements-v3.component';
import { DailyStatsV1Component } from './widgets/daily-stats-v1/daily-stats-v1.component';
import { DailyStatsComponent } from './widgets/daily-stats/daily-stats.component';
import { DailymetricsR5Component } from './widgets/dailymetrics-r5/dailymetrics-r5.component';
import { DataSourceDropdownComponent } from './widgets/datasource-dropdown/datasource-dropdown.component';
import { DatatableCarouselComponent } from './widgets/datatable-carousel/datatable-carousel.component';
import { DatatableR10Component } from './widgets/datatable-r10/datatable-r10.component';
import { DatatableV3Component } from './widgets/datatable-v3/datatable-v3.component';
import { DatatableV4Component } from './widgets/datatable-v4/datatable-v4.component';
import { DatatableV5Component } from './widgets/datatable-v5/datatable-v5.component';
import { DataTableComponent } from './widgets/datatable/datatable.component';
import { DatepickerComponent } from './widgets/datepicker/datepicker.component';
import { NgxDaterangepickerMd } from './widgets/daterangepicker';
import { DaypartChartV11Component } from './widgets/daypart-chart-v11/daypart-chart-v11.component';
import { DaypartChartComponent } from './widgets/daypart-chart/daypart-chart.component';
import { DaypartDonutComponent } from './widgets/daypart-donut/daypart-donut.component';
import { DaysFilterR10Component } from './widgets/days-filter-r10/days-filter-r10.component';
import { DemographicsR11Component } from './widgets/demographics-r11/demographics-r11.component';
import { DemographicsR7Component } from './widgets/demographics-r7/demographics-r7.component';
import { DemographicsV5Component } from './widgets/demographics-v5/demographics-v5.component';
import { DeviceCarouselV1Component } from './widgets/device-donut-carousel-v1/device-donut-carousel-v1.component';
import { DeviceDonutComponent } from './widgets/device-donut/device-donut.component';
import { DeviceTableComponent } from './widgets/device-table/device-table.component';
import { DevicesCardV3Component } from './widgets/devices-card-v3/devices-card-v3.component';
import { DevicesPlacementsV3Component } from './widgets/devices-placements-v3/devices-placements-v3.component';
import { DevicesV4Component } from './widgets/devices-v4/devices-v4.component';
import { Devicesr6Component } from './widgets/devicesr6/devicesr6.component';
import { Devicesr7Component } from './widgets/devicesr7/devicesr7.component';
import { DisplayCreativeR4Component } from './widgets/display-creative-r4/display-creative-r4.component';
import { DisplayCreativeR5Component } from './widgets/display-creative-r5/display-creative-r5.component';
import { DisplayCreativeV3Component } from './widgets/display-creative-v3/display-creative-v3.component';
import { DisplayCreativeComponent } from './widgets/display-creative/display-creative.component';
import { DonutLegendItemComponent } from './widgets/donut/donut-legend-item/donut-legend-item.component';
import { DonutComponent } from './widgets/donut/donut.component';
import { DropdownComponent } from './widgets/dropdown/dropdown.component';
import { DynamicChartComponent } from './widgets/dynamic-chart/dynamic-chart.component';
import { EnterpriseReportsGeneratorComponent } from './widgets/enterprise-reports-generator/enterprise-reports-generator.component';
import { FocusDirective } from './widgets/enterprise-reports-generator/focus.directive';
import { FeaturedNetworksR10Component } from './widgets/featured-networks-r10/featured-networks-r10.component';
import { GeofenceAppsR6Component } from './widgets/geofence-apps-r6/geofence-apps-r6.component';
import { GeofenceAppsV3Component } from './widgets/geofence-apps-v3/geofence-apps-v3.component';
import { GeofenceAppsComponent } from './widgets/geofence-apps/geofence-apps.component';
import { GeofenceCreativeR4Component } from './widgets/geofence-creative-r4/geofence-creative-r4.component';
import { HalfDonutComponent } from './widgets/half-donut/half-donut.component';
import { LazyDropdownV2Component } from './widgets/lazy-dropdown-v2/lazy-dropdown-v2.component';
import { LazyDropdownComponent } from './widgets/lazy-dropdown/lazy-dropdown.component';
import { LiftCardV3Component } from './widgets/lift-card-v3/lift-card-v3.component';
import { LiftChartComponent } from './widgets/lift-chart/lift-chart.component';
import { LiftStatsR11Component } from './widgets/lift-stats-r11/lift-stats-r11.component';
import { LiftStatsR5Component } from './widgets/lift-stats-r5/lift-stats-r5.component';
import { LiftStatsR7Component } from './widgets/lift-stats-r7/lift-stats-r7.component';
import { LiftStatsV2Component } from './widgets/lift-stats-v2/lift-stats-v2.component';
import { LiftStatsComponent } from './widgets/lift-stats/lift-stats.component';
import { LoaderComponent } from './widgets/loader/loader.component';
import { MapOverviewStatsComponent } from './widgets/map-overview-stats/map-overview-stats.component';
import { MapR10Component } from './widgets/map-r10/map-r10.component';
import { MapR13Component } from './widgets/map-r13/map-r13.component';
import { MapV3BetaComponent } from './widgets/map-v3-beta/map-v3-beta.component';
import { MapV3Component } from './widgets/map-v3/map-v3.component';
import { MapV4Component } from './widgets/map-v4/map-v4.component';
import { MapV5BetaComponent } from './widgets/map-v5-beta/map-v5-beta.component';
import { MapV5Component } from './widgets/map-v5/map-v5.component';
import { MapV6Component } from './widgets/map-v6/map-v6.component';
import { MapV7Component } from './widgets/map-v7/map-v7.component';
import { LiftHistogramComponent } from './widgets/map/lift-histogram/lift-histogram.component';
import { MapComponent } from './widgets/map/map.component';
import { MarketronDisplayCreativeComponent } from './widgets/marketron-display-creative/marketron-display-creative.component';
import { MarketronMapComponent } from './widgets/marketron-map/marketron-map.component';
import { MarketronPrerollCreativeComponent } from './widgets/marketron-preroll-creative/marketron-preroll-creative.component';
import { NavTabComponent } from './widgets/nav-tab/nav-tab.component';
import { NavigationCarouselComponent } from './widgets/navigation-carousel/navigation-carousel.component';
import { NetworkAndShowsR5Component } from './widgets/network-and-shows-r5/network-and-shows-r5.component';
import { NgxDateRangePickerInlineComponent } from './widgets/ngx-date-range-picker-inline/ngx-date-range-picker-inline.component';
import { NgxDateRangePickerComponent } from './widgets/ngx-date-range-picker/ngx-date-range-picker.component';
import { OverviewR3StatsComponent } from './widgets/overview-r3-stats/overview-r3-stats.component';
import { OverviewSummaryComponentR7 } from './widgets/overview-summary-r7/overview-summary-r7.component';
import { OverviewSummaryComponent } from './widgets/overview-summary/overview-summary.component';
import { PartnerNameComponent } from './widgets/partner-name/partner-name.component';
import { PerformaceCreativeV6Component } from './widgets/performace-creative-v6/performace-creative-v6.component';
import { PerformanceByDayDisplayV6Component } from './widgets/performance-by-day-display-v6/performance-by-day-display-v6.component';
import { PlacementsV4Component } from './widgets/placements-v4/placements-v4.component';
import { PlacementsComponent } from './widgets/placements/placements.component';
import { PrerollCreativeR5Component } from './widgets/preroll-creative-r5/preroll-creative-r5.component';
import { PrerollCreativeV3Component } from './widgets/preroll-creative-v3/preroll-creative-v3.component';
import { PrerollCreativeV4Component } from './widgets/preroll-creative-v4/preroll-creative-v4.component';
import { PrerollCreativeComponent } from './widgets/preroll-creative/preroll-creative.component';
import { PrerollQuickStatsComponent } from './widgets/preroll-quick-stats/preroll-quick-stats.component';
import { CustomProgressBarComponent } from './widgets/presentational/custom-progress-bar/custom-progress-bar.component';
import { CustomVideoPlayerComponent } from './widgets/presentational/custom-video-player/custom-video-player.component';
import { UiKitChartComponent } from './widgets/presentational/generic-chart/generic-chart.component';
import { PrintableReportComponentR1 } from './widgets/printable-report-r1/printable-report-r1.component';
import { PrintableReportComponent } from './widgets/printable-report/printable-report.component';
import { ProductCsvDownloadComponent } from './widgets/product-csv-download/product-csv-download.component';
import { ProductLiftChartR10Component } from './widgets/product-lift-chart-r10/product-lift-chart-r10.component';
import { ProductLiftChartR11Component } from './widgets/product-lift-chart-r11/product-lift-chart-r11.component';
import { ProductLiftChartR5Component } from './widgets/product-lift-chart-r5/product-lift-chart-r5.component';
import { ProductLiftChartR7Component } from './widgets/product-lift-chart-r7/product-lift-chart-r7.component';
import { ProductLiftChartComponent } from './widgets/product-lift-chart/product-lift-chart.component';
import { ProductLiftTableComponent } from './widgets/product-lift-table/product-lift-table.component';
import { ProductOverviewR10Component } from './widgets/product-overview-r10/product-overview-r10.component';
import { QuickStatsR10Component } from './widgets/quick-stats-r10/quick-stats-r10.component';
import { QuickStatsR5Component } from './widgets/quick-stats-r5/quick-stats-r5.component';
import { QuickStatsComponent } from './widgets/quick-stats/quick-stats.component';
import { R3ConversionsComponent } from './widgets/r3-conversions/r3-conversions.component';
import { R10DaypartComponent } from './widgets/r10-daypart/r10-daypart.component';
import { R10DemographicsComponent } from './widgets/r10-demographics/r10-demographics.component';
import { R10DevicesComponent } from './widgets/r10-devices/r10-devices.component';
import { R10PlatformPerformanceComponent } from './widgets/r10-platform-performance/r10-platform-performance.component';
import { R4MapOverviewStatsComponent } from './widgets/r4-map-overview-stats/r4-map-overview-stats.component';
import { R5CalendarClose } from './widgets/r5-calendar-close/r5-calendar-close.component';
import { R5DevicesComponent } from './widgets/r5-devices/r5-devices.component';
import { R6DaypartComponent } from './widgets/r6-daypart/r6-daypart.component';
import { R6MapOverviewStatsComponent } from './widgets/r6-map-overview-stats/r6-map-overview-stats.component';
import { R6MarketronMapComponent } from './widgets/r6-marketron-map/r6-marketron-map.component';
import { R7LiftHistogramComponent } from './widgets/r7-lift-histogram/r7-lift-histogram.component';
import { ScatterPlotChartComponent } from './widgets/scatter-plot-chart/scatter-plot-chart.component';
import { ScreenshotsR10Component } from './widgets/screenshots-r10/screenshots-r10.component';
import { ScreenshotsR11Component } from './widgets/screenshots-r11/screenshots-r11.component';
import { ScreenshotsR5Component } from './widgets/screenshots-r5/screenshots-r5.component';
import { ScreenshotsComponent } from './widgets/screenshots/screenshots.component';
import { SwiperDirective } from './widgets/section-carousel/directives/swiper.directive';
import { SectionCarouselDotsComponent } from './widgets/section-carousel/section-carousel-dots/section-carousel-dots.component';
import { SectionCarouselItemComponent } from './widgets/section-carousel/section-carousel-item/section-carousel-item.component';
import { SectionCarouselComponent } from './widgets/section-carousel/section-carousel.component';
import { SemCallsR10Component } from './widgets/sem-calls-r10/sem-calls-r10.component';
import { SemCallsR11Component } from './widgets/sem-calls-r11/sem-calls-r11.component';
import { SemCallsR5Component } from './widgets/sem-calls-r5/sem-calls-r5.component';
import { SemCallsV1Component } from './widgets/sem-calls-v1/sem-calls-v1.component';
import { SemCallsV2Component } from './widgets/sem-calls-v2/sem-calls-v2.component';
import { SemCallsV3Component } from './widgets/sem-calls-v3/sem-calls-v3.component';
import { SemCallsV4Component } from './widgets/sem-calls-v4/sem-calls-v4.component';
import { SemCallsV5Component } from './widgets/sem-calls-v5/sem-calls-v5.component';
import { SemCallsV6Component } from './widgets/sem-calls-v6/sem-calls-v6.component';
import { SemCreativeCardV1Component } from './widgets/sem-creative-card-v1/sem-creative-card-v1.component';
import { SemCreativeCardV2Component } from './widgets/sem-creative-card-v2/sem-creative-card-v2.component';
import { SemCreativeCardV3Component } from './widgets/sem-creative-card-v3/sem-creative-card-v3.component';
import { SemCreativeCardV4Component } from './widgets/sem-creative-card-v4/sem-creative-card-v4.component';
import { SemCreativeCardComponent } from './widgets/sem-creative-card/sem-creative-card.component';
import { SemCreativeCoxV5Component } from './widgets/sem-creative-cox-v5/sem-creative-cox-v5.component';
import { SemCreativeV7Component } from './widgets/sem-creative-v7/sem-creative-v7.component';
import { SemKeywordsR10Component } from './widgets/sem-keywords-r10/sem-keywords-r10.component';
import { SemKeywordsV1Component } from './widgets/sem-keywords-v1/sem-keywords-v1.component';
import { SemKeywordsV4Component } from './widgets/sem-keywords-v4/sem-keywords-v4.component';
import { SemKeywordsV5Component } from './widgets/sem-keywords-v5/sem-keywords-v5.component';
import { SemQuickStatsV7Component } from './widgets/sem-quick-stats-v7/sem-quick-stats-v7.component';
import { SemQuickStatsComponent } from './widgets/sem-quick-stats/sem-quick-stats.component';
import { SingleStatComponent } from './widgets/single-stat/single-stat.component';
import { SocialDemographComponent } from './widgets/social-demograph/social-demograph.component';
import { SocialDemographicsR1Component } from './widgets/social-demographics-r1/social-demographics-r1.component';
import { SocialDemographicsR2Component } from './widgets/social-demographics-r2/social-demographics-r2.component';
import { SocialDemographicsV3Component } from './widgets/social-demographics-v3/social-demographics-v3.component';
import { SocialDemographicsV4Component } from './widgets/social-demographics-v4/social-demographics-v4.component';
import { SocialDemographicsV6Component } from './widgets/social-demographics-v6/social-demographics-v6.component';
import { SolidgaugeDonutComponent } from './widgets/solidgauge-donut/solidgauge-donut.component';
import { SparklineComponent } from './widgets/sparkline/sparkline.component';
import { StreamingAudioQuickstatsR1Component } from './widgets/streaming-audio-quickstats-r1/streaming-audio-quickstats-r1.component';
import { SubNavComponent } from './widgets/sub-nav/sub-nav.component';
import { TableHorizontalComponent } from './widgets/table-horizontal/table-horizontal.component';
import { TableProgressbar } from './widgets/table-progressbar/table-progressbar.component';
import { TvDailyMetricsComponent } from './widgets/tv-daily-metrics/tv-daily-metrics.component';
import { TvNetworkProgramV1Component } from './widgets/tv-network-program-v1/tv-network-program-v1.component';
import { VideoCreativeR7Component } from './widgets/video-creative-r7/video-creative-r7.component';
import { VideoPlayerComponent } from './widgets/video-player/video-player.component';
import { TimelineChartComponent } from './widgets/timeline-chart/timeline-chart.component';
import { RadioCreativeR1Component } from './widgets/radio-creative-r1/radio-creative-r1.component';
import { AudioPlayerComponent } from './widgets/audio-player/audio-player.component';
import { PrintableNavComponent } from './widgets/printable-nav/printable-nav.component';
import { MarketronAudioCreativeComponent } from './widgets/marketron-audio-creative/marketron-audio-creative.component';
import { SemCallsR10ReskinComponent } from './widgets/sem-calls-r10-reskin/sem-calls-r10-reskin.component';
import { LiftChartR10ReskinComponent } from './widgets/lift-chart-r10-reskin/lift-chart-r10-reskin.component';
import { ProductDownloadR10Component } from './widgets/product-download-r10/product-download-r10.component';
import { UniqueReachAndFrequencyR13Component } from './widgets/unique-reach-and-frequency-r13/unique-reach-and-frequency-r13.component';
import { UniqueReachAndFrequencyComponent } from './widgets/unique-reach-and-frequency/unique-reach-and-frequency.component';
import { UniqueReachAndFrequencyR3Component } from './widgets/unique-reach-and-frequency-r3/unique-reach-and-frequency-r3.component';
import { WelcomeUserComponent } from './welcome-user/welcome-user.component';
import { NavigateToDefaultRouteComponent } from './widgets/navigate-to-default-route/navigate-to-default-route.component';
import { SemResponsiveSearchAdsComponent } from './widgets/sem-responsive-search-ads/sem-responsive-search-ads.component';
import { Conversionr6Component } from './widgets/conversionr6/conversionr6.component';
import { R13SemConversionsComponent } from './widgets/r13-sem-conversions/r13-sem-conversions.component';
import { R5SemCoversionsComponent } from './widgets/r5-sem-coversions/r5-sem-coversions.component';
import { CustomDisclaimerComponent } from './widgets/custom-disclaimer/custom-disclaimer.component';
import { EmailBrowserR13Component } from './widgets/email-browser-r13/email-browser-r13.component';
import { EmailLinkSummaryR13Component } from './widgets/email-link-summary-R13/email-link-summary-r13.component';
import { R4ConversionsComponent } from './widgets/r4-conversions/r4-conversions.component';
import { R10ConversionsComponent } from './widgets/r10-conversions/r10-conversions.component';
import { R2ConversionsComponent } from './widgets/r2-conversions/r2-conversions.component';
import { R1SemConversionsComponent } from './widgets/r1-sem-conversions/r1-sem-conversions.component';
import { R7SemConversionsComponent } from './widgets/r7-sem-conversions/r7-sem-conversions.component';
import { LineItemsComponent } from './widgets/line-items/line-items.component';
import { SemAdAssetsComponent } from './widgets/sem-ad-assets/sem-ad-assets.component';
import { R103TimeOfTheDayComponent } from './widgets/r103-time-of-the-day/r103-time-of-the-day.component';
import { R1301OverviewDevicesComponent } from './widgets/r1301-overview-devices/r1301-overview-devices.component';
import { CtvDaypartsComponent } from './widgets/ctv-dayparts/ctv-dayparts.component';
import { VenueTypeComponent } from './widgets/venue-type/venue-type.component';
import { EmailDevicesBrowsersV4Component } from './widgets/email-devices-browsers-v4/email-devices-browsers-v4.component';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
	suppressScrollX: true
};

@NgModule({
	declarations: [
		WidgetLibraryComponent,
		QuickStatsComponent,
		LiftStatsComponent,
		LiftStatsR7Component,
		ProductLiftChartR10Component,
		SparklineComponent,
		DonutComponent,
		DeviceTableComponent,
		OverviewSummaryComponent,
		OverviewSummaryComponentR7,
		CarouselComponent,
		DatepickerComponent,
		DropdownComponent,
		CustomDropdownComponent,
		CreativeCarouselComponent,
		LiftChartComponent,
		ChartComponent,
		ProductLiftChartComponent,
		ProductLiftChartR7Component,
		MapComponent,
		LoaderComponent,
		PlacementsComponent,
		DisplayCreativeComponent,
		FormatNumberPipe,
		PrerollQuickStatsComponent,
		ScreenshotsComponent,
		PrerollCreativeComponent,
		PartnerNameComponent,
		MarketronMapComponent,
		SingleStatComponent,
		SafeUrlPipe,
		MapOverviewStatsComponent,
		DailyStatsComponent,
		GeofenceAppsComponent,
		ProductLiftTableComponent,
		TableHorizontalComponent,
		AccordionComponent,
		AccordionGroupComponent,
		MarketronDisplayCreativeComponent,
		MarketronPrerollCreativeComponent,
		CreativeDetailV2Component,
		VideoPlayerComponent,
		DataTableComponent,
		DailyStatsV1Component,
		ProductCsvDownloadComponent,
		LiftHistogramComponent,
		LiftStatsV2Component,
		CreativePerformanceV1Component,
		CreativePerformanceGraphComponent,
		CreativePerformanceStatsComponent,
		SemQuickStatsComponent,
		SemQuickStatsV7Component,
		CreativeAdPreviewComponent,
		SemKeywordsV1Component,
		SemCallsV1Component,
		DeviceCarouselV1Component,
		DeviceDonutComponent,
		DynamicChartComponent,
		SemCreativeCardV1Component,
		SemCreativeCardV2Component,
		SemCreativeCardComponent,
		SemCallsV2Component,
		SubNavComponent,
		DevicesCardV3Component,
		LiftCardV3Component,
		DisplayCreativeV3Component,
		ChartV3Component,
		PrerollCreativeV3Component,
		DatatableV3Component,
		OverviewR3StatsComponent,
		MapV3Component,
		DatatableCarouselComponent,
		DailyEnagementsV3Component,
		DevicesPlacementsV3Component,
		SectionCarouselComponent,
		SectionCarouselItemComponent,
		SwiperDirective,
		SectionCarouselDotsComponent,
		SemCallsV3Component,
		SemCreativeCardV3Component,
		DonutLegendItemComponent,
		EnterpriseReportsGeneratorComponent,
		SearchReportAttributesPipe,
		CtvFeaturedNetworksComponent,
		CtvNetworkDonutComponent,
		CtvPlatformPerformanceComponent,
		CtvCreativeDetailV2Component,
		CtvCreativeDetailV3Component,
		LazyDropdownComponent,
		GeofenceAppsV3Component,
		CtvQuickstatsR1Component,
		CtvQuickstatsR7Component,
		CtvCreativeR1Component,
		CtvFeaturedNetworksR1Component,
		NavigationCarouselComponent,
		DisplayCreativeR4Component,
		HalfDonutComponent,
		MapV4Component,
		MapV5Component,
		MapV5BetaComponent,
		DatatableV4Component,
		PlacementsV4Component,
		SemKeywordsV4Component,
		SemCallsV4Component,
		DevicesV4Component,
		GeofenceCreativeR4Component,
		PrerollCreativeV4Component,
		CtvCreativeDetailV4Component,
		SemCreativeCardV4Component,
		MapV3BetaComponent,
		CtvPlatformPerformanceR3Component,
		DataSourceDropdownComponent,
		QuickStatsR5Component,
		R5CalendarClose,
		CreativesR5Component,
		CreativeR5GraphComponent,
		DailymetricsR5Component,
		ProductLiftChartR5Component,
		LiftStatsR5Component,
		DisplayCreativeR5Component,
		CreativeR5GraphComponent,
		NetworkAndShowsR5Component,
		SemKeywordsV5Component,
		DatatableV5Component,
		R5DevicesComponent,
		SocialDemographicsR2Component,
		CreativesCoxV5Component,
		SemCreativeCoxV5Component,
		DaypartChartComponent,
		TvDailyMetricsComponent,
		SemCallsR5Component,
		SocialDemographicsV3Component,
		SocialDemographicsV4Component,
		SocialDemographicsV6Component,
		NgxDateRangePickerComponent,
		SocialDemographComponent,
		SocialDemographicsR1Component,
		FocusDirective,
		ScreenshotsR5Component,
		DemographicsV5Component,
		CreativeCarouselR5Component,
		PrerollCreativeR5Component,
		CtvCreativeR5Component,
		PerformanceByDayDisplayV6Component,
		PerformaceCreativeV6Component,
		Devicesr6Component,
		Conversionr6Component,
		SolidgaugeDonutComponent,
		GeofenceAppsR6Component,
		R6MapOverviewStatsComponent,
		R6MarketronMapComponent,
		SemCallsV6Component,
		R4MapOverviewStatsComponent,
		PrintableReportComponent,
		PrintableReportComponentR1,
		DaypartDonutComponent,
		CtvPerformanceDetailV4Component,
		DemographicsR7Component,
		CreativePerformanceV7Component,
		CreativePerformanceStatsV7Component,
		CreativePerformanceGraphV7Component,
		CreativeDetailV7Component,
		SemCreativeV7Component,
		VideoCreativeR7Component,
		MapV7Component,
		R7LiftHistogramComponent,
		Devicesr7Component,
		CtvDaypartR7Component,
		TvNetworkProgramV1Component,
		CtvDaypartsR1Component,
		ScatterPlotChartComponent,
		SemCallsV5Component,
		R6DaypartComponent,
		MapV6Component,
		SemCallsR11Component,
		DemographicsR11Component,
		DaypartChartV11Component,
		NavTabComponent,
		ScreenshotsR10Component,
		ScreenshotsR11Component,
		ProductLiftChartR11Component,
		LiftStatsR11Component,
		ProductOverviewR10Component,
		LazyDropdownV2Component,
		BreadcrumbDrawerComponent,
		NgxDateRangePickerInlineComponent,
		BaseWidgetComponent,
		R10PlatformPerformanceComponent,
		R10DemographicsComponent,
		MapR10Component,
		FeaturedNetworksR10Component,
		DatatableR10Component,
		CreativeR10Component,
		CustomVideoPlayerComponent,
		CustomProgressBarComponent,
		FeaturedNetworksR10Component,
		QuickStatsR10Component,
		UiKitChartComponent,
		DaysFilterR10Component,
		SemCallsR10Component,
		SemKeywordsR10Component,
		R3ConversionsComponent,
		R10DevicesComponent,
		R10DaypartComponent,
		TimelineChartComponent,
		MapR13Component,
		RadioCreativeR1Component,
		StreamingAudioQuickstatsR1Component,
		TableProgressbar,
		AudioPlayerComponent,
		PrintableNavComponent,
		MarketronAudioCreativeComponent,
		SemCallsR10ReskinComponent,
		LiftChartR10ReskinComponent,
		ProductDownloadR10Component,
		UniqueReachAndFrequencyR13Component,
		UniqueReachAndFrequencyComponent,
		UniqueReachAndFrequencyR3Component,
		WelcomeUserComponent,
		NavigateToDefaultRouteComponent,
		SemResponsiveSearchAdsComponent,
		R13SemConversionsComponent,
		R5SemCoversionsComponent,
		CustomDisclaimerComponent,
		EmailBrowserR13Component,
		EmailLinkSummaryR13Component,
		R4ConversionsComponent,
		R10ConversionsComponent,
		R2ConversionsComponent,
		R1SemConversionsComponent,
		R7SemConversionsComponent,
		LineItemsComponent,
		SemAdAssetsComponent,
		R1301OverviewDevicesComponent,
		CtvDaypartsComponent,
		R103TimeOfTheDayComponent,
		VenueTypeComponent,
		EmailDevicesBrowsersV4Component
	],
	exports: [],
	imports: [
		FormsModule,
		CommonModule,
		BrowserModule,
		AngularMultiSelectModule,
		NgxDatatableModule,
		NguCarouselModule,
		Daterangepicker,
		AnalyticsCoreModule,
		NgSelectModule,
		SortablejsModule,
		PerfectScrollbarModule,
		SharedModule,
		NgxPaginationModule,
		UiSwitchModule,
		NavigationModule,
		FqProgressBarModule,
		FqVideoPlayerModule,
		TooltipModule,
		NgxCarousel3dModule,
		NgxPaginationModule,
		NgxDaterangepickerMd.forRoot(),
		FqProgressBarModule,
		FqVideoPlayerModule,
		FqCreativeModule,
		FqChartModule,
		FqAudioPlayerModule
	],
	providers: [
		WidgetLibraryService,
		{
			provide: PERFECT_SCROLLBAR_CONFIG,
			useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
		}
	]
})
export class WidgetLibraryModule {}
